import { inject, injectable } from 'inversify';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';
import Request from '@framework/api/Rpc/Request';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { IDataroomStage } from '@dataroom/entity/DataroomStage';

@injectable()
class DataroomStageRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  getStageData = async (payload: { dataroomId: number }): Promise<{ investorsCount: number }> => {
    const request = new Request('dataroom.stages.get_move_preparation_info', payload);
    const response = await this.rpc()
      .call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getStageList = async (): Promise<IDataroomStage[]> => {
    const request = new Request('dataroom.stages.get_list');
    const response = await this.rpc()
      .call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  moveDataroomStage = async (payload: {
      dataroomId: number,
    },
  ): Promise<{ investorsCount: number }> => {
    const request = new Request('dataroom.stages.move', payload);
    const response = await this.rpc()
      .call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default DataroomStageRepository;
